export default {"src":"/_next/static/image/src/onboarding/AccountFeatures/box-frequency.f4f079877f39f974f2f35e5d21949136.svg","height":70,"width":69};